/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

// import { useSelector } from 'react-redux'
import { useIsAuthenticated } from "@azure/msal-react";
import { Logger } from "cms/utils/logger";
import { CmsConfig } from "../config";
import { useSelector } from "react-redux";

const NotAuthCustomerGuard = (props) => {

    const { children } = props;
    const enableCustomerAuth = CmsConfig.enableCustomerAuth;
    const authenticated_ms = useIsAuthenticated();
    const authenticated_mock = useSelector((state) => {
        return state.authCustomer.authenticated;
    });
    const authenticated = enableCustomerAuth
        ? authenticated_ms
        : authenticated_mock;

    Logger.info(`[authenticated : ${authenticated}]`);

    if (authenticated) {
        return null;
    }
    return (
        <>{children}</>
    );
};

export { NotAuthCustomerGuard };
